import request from '@/utils/request'

/**
 * 机构列表
 */
export function InstitutionsList (page, size) {
  return request({
    url: 'Institutions/list',
    method: 'post',
    data: {
      page: page,
      size: size
    }
  })
}

/**
 * 机构列表修改 & 新增
 */
export function InstitutionsEdit (data) {
  return request({
    url: 'Institutions/edit',
    method: 'post',
    data
  })
}

/**
 * 新增队列
 */
export function addCustomGroup (data) {
  return request({
    url: 'Institutions/addCustomGroup',
    method: 'post',
    data
  })
}
